module.exports = __webpack_public_path__ + "e5b1f75b66ebb443987ee3d7feacb03b.svg";